<template>
  <b-card class="chapter mb-3">
    <div :class="chapterStatusClasses()" v-b-popover.hover.left="chapterPopoverContent()"></div>
    <b-row>
      <b-col cols="auto" class="d-flex align-items-center flex-column justify-content-center">
        <div class="chapter__drag-handle">
          <svg viewBox="0 0 421.285 421.285"><path d="M418.742,203.942c-0.3-0.2-0.5-0.5-0.8-0.8l-50.6-44.8c-4.1-3.6-10.5-3.2-14.1,0.9c-3.6,4.1-3.2,10.4,0.8,14l30.9,27.4h-164.3v-164.3l27.3,30.8c3.7,4.1,10,4.5,14.1,0.8s4.5-10,0.8-14.1l-44.8-50.5c-3.7-4.1-10-4.5-14.1-0.8c-0.3,0.3-0.6,0.5-0.8,0.8l-44.8,50.5c-3.6,4.1-3.2,10.5,0.9,14.1c4.1,3.6,10.4,3.2,14-0.8l27.3-30.8v164.3h-164.2l30.8-27.3c4.1-3.7,4.5-10,0.8-14.1c-3.7-4.1-10-4.5-14.1-0.8l-50.5,44.8c-4.1,3.7-4.5,10-0.8,14.1c0.3,0.3,0.5,0.6,0.8,0.8l50.5,44.8c4.1,3.6,10.5,3.2,14.1-0.9c3.6-4.1,3.2-10.4-0.8-14l-30.8-27.4h164.3v164.3l-27.3-30.8c-3.7-4.1-10-4.5-14.1-0.8c-4.1,3.7-4.5,10-0.8,14.1l44.8,50.5c3.7,4.1,10,4.5,14.1,0.8c0.3-0.3,0.6-0.5,0.8-0.8l44.8-50.5c3.6-4.1,3.2-10.5-0.9-14.1c-4.1-3.6-10.4-3.2-14,0.8l-27.4,30.8v-164.3h164.3l-30.8,27.3c-4.1,3.7-4.5,10-0.8,14.1c3.7,4.1,10,4.5,14.1,0.8l50.5-44.8C422.042,214.342,422.442,208.042,418.742,203.942z"/></svg>
        </div>
        <div class="chapter__order">{{ chapter.order }}</div>
      </b-col>
      <b-col cols="4">
        <div class="chapter__title">
          <router-link
            :to="{
              name: 'MonitorsParagraphs',
              params: {
                monitorId: monitorCurrent.monitor.id,
                chapterId: chapter.id
              }
            }"
            @click.native="setCurrentChapter()"
          >
            {{ chapter.name }}
          </router-link>
        </div>
        <div class="chapter__actions">
          <button class="chapter__action mr-2" @click="requestChapterPublish()" v-b-popover.hover.top="'Publish'" v-if="chapter.published === false && chapterCanBePublished === true">
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m8.75 17.612v4.638c0 .324.208.611.516.713.077.025.156.037.234.037.234 0 .46-.11.604-.306l2.713-3.692z"/><path d="m23.685.139c-.23-.163-.532-.185-.782-.054l-22.5 11.75c-.266.139-.423.423-.401.722.023.3.222.556.505.653l6.255 2.138 13.321-11.39-10.308 12.419 10.483 3.583c.078.026.16.04.242.04.136 0 .271-.037.39-.109.19-.116.319-.311.352-.53l2.75-18.5c.041-.28-.077-.558-.307-.722z"/></svg>
          </button>
          <button class="chapter__action mr-2" @click="requestChapterEdit()" v-b-popover.hover.top="'Edit'">
            <svg viewBox="0 0 488.471 488.471"><path d="m166.093 240.214h88.205v194.288h-88.205z" transform="matrix(.707 -.707 .707 .707 1.415 9.959)"/><path d="m245.547 105.541-245.547 245.547v137.382h137.382l245.548-245.547z"/></svg>
          </button>
          <button class="chapter__action mr-2" @click="chapterDuplicate()" v-b-popover.hover.top="'Duplicate'">
            <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m407 15v90h90zm0 0"/><path d="m377 135v-135h-197v60h44.425781l8.789063 8.785156 120 120 8.785156 8.789063v224.425781h150v-287zm0 0"/><path d="m227 195h90l-90-90zm0 0"/><path d="m197 90h-197v422h332v-287h-135zm0 0"/></svg>
          </button>
          <button class="chapter__action" @click="requestChapterDelete()" v-b-popover.hover.top="'Delete'">
            <svg viewBox="0 0 515.556 515.556"><path d="m64.444 451.111c0 35.526 28.902 64.444 64.444 64.444h257.778c35.542 0 64.444-28.918 64.444-64.444v-322.222h-386.666z"/><path d="m322.222 32.222v-32.222h-128.889v32.222h-161.111v64.444h451.111v-64.444z"/></svg>
          </button>
        </div>
        <p class="chapter__last-updated" v-if="chapter.updated_at"><small>Last update {{ chapter.updated_at | moment('YYYY-MM-DD') }}</small></p>
      </b-col>
      <b-col class="d-flex align-items-center justify-content-end" v-if="chapter.number_of_objects == 0">
        <b-button variant="primary" :to="{ name: 'MonitorsParagraphs', params: { monitorId: monitorCurrent.monitor.id, chapterId: chapter.id }}" @click.native="setCurrentChapter()">
          Set up chapter
        </b-button>
      </b-col>
      <b-col v-else>
        <template v-if="isLoading">
          <div class="d-flex flex-column justify-content-center text-center align-items-center app__loading">
            <b-spinner small></b-spinner>
          </div>
        </template>
        <b-card
          v-for="paragraph in paragraphsList"
          :key="paragraph.id"
          class="paragraph mb-2"
        >
          <div :class="paragraphStatusClasses(paragraph)" v-b-popover.hover.left="paragraphPopoverContent(paragraph)"></div>
          <b-card-text>
            <span class="paragraph__order">{{ paragraph.order }}</span> {{ paragraph.name }}
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { mapGetters } from "vuex";

import {
  MONITOR_PARAGRAPH_GET_ALL,
  MONITOR_CHAPTER_DUPLICATE
} from "@/store/actions.type";

import {
  STATE_MONITORS_CURRENT_CHAPTER_SET
} from "@/store/mutations.type";

export default {
  name: 'MonitorChapter',
  props: ['chapter'],
  data() {
    return {
      isLoading: true,
      paragraphsList: []
    }
  },
  computed: {
    ...mapGetters(["monitorTags", "monitorCurrent"]),
    chapterCanBePublished: function() {
      for (let i = 0; i < this.paragraphsList.length; i++) {
        const element = this.paragraphsList[i];
        if(element.paragraph_is_empty === false) {
          return true
        }
      }
      return false
    }
  },
  methods: {
    async getParagraphs() {
      await this.$store.dispatch(MONITOR_PARAGRAPH_GET_ALL, this.chapter.id).then((data) => {
        this.paragraphsList = data;
        this.isLoading = false;
      });
    },
    chapterPopoverContent() {
      if(this.paragraphsList.length === 0) {
        return 'Empty'
      } else if(this.chapter.published === false) {
        return 'Draft'
      } else {
        return 'Online'
      }
    },
    chapterStatusClasses() {
      return {
        'chapter__status': true,
        'chapter__status--draft': this.chapter.published === false,
        'chapter__status--empty': this.paragraphsList.length === 0, 
        'chapter__status--published': this.chapter.published === true
      }
    },
    setCurrentChapter() {
      this.$store.commit(STATE_MONITORS_CURRENT_CHAPTER_SET, this.chapter);
    },
    // chapterPublish() {
    //   let chapterData = new FormData();
    //   chapterData.set('monitor_id', this.monitorCurrent.monitor.monitor_id);
    //   chapterData.append('chapter_ids', this.chapter.chapter_id);

    //   this.$store.dispatch(MONITOR_CHAPTER_PUBLISH, chapterData).then(() => {
    //     this.$bvToast.toast(`Chapter ${this.chapter.chapter_title} has been published`, {
    //       title: 'Chapter published',
    //       toaster: 'b-toaster-bottom-right',
    //       autoHideDelay: 40000,
    //       variant: 'primary'
    //     });
    //     this.getParagraphs();
    //     this.$emit('chapterPublished');
    //   });
    // },
    requestChapterEdit() {
      this.$emit('requestChapterEdit', this.chapter);
    },
    requestChapterDelete() {
      this.$emit('requestChapterDelete', this.chapter);
    },
    requestChapterPublish() {
      this.$emit('requestChapterPublish', this.chapter);
    },
    chapterDuplicate() {
      // let chapterData = new FormData();
      // chapterData.append('ids', this.chapter.chapter_id);

      this.$store.dispatch(MONITOR_CHAPTER_DUPLICATE, this.chapter.id).then(() => {
        this.$bvToast.toast(`Chapter ${this.chapter.name} has been duplicated`, {
          title: 'Chapter duplicated',
          toaster: 'b-toaster-bottom-right',
          autoHideDelay: 40000,
          variant: 'primary'
        });
        this.$emit('chapterDuplicated');
      });  
    },
    paragraphPopoverContent(paragraph) {
      if(paragraph.paragraph_is_empty === true) {
        return 'Empty'
      } else if(paragraph.published === false) {
        return 'Draft'
      } else {
        return 'Online'
      }
    },
    paragraphStatusClasses(paragraph) {
      return {
        'chapter__status': true,
        'chapter__status--draft': paragraph.published === false,
        'chapter__status--empty': paragraph.paragraph_is_empty === true, 
        'chapter__status--published': paragraph.published === true
      }
    },
  },
  mounted() {
    this.getParagraphs();
  },
  watch: {
    chapter: function() {
      this.getParagraphs();
    }
  }
}
</script>

<style lang="scss" scoped>
.chapter {
  position: relative;

  &__status {
    position: absolute;
    left: 0;
    top: 0;
    width: rem(10px);
    height: 100%;
    border-top-left-radius: rem(8px);
    border-bottom-left-radius: rem(8px);
    z-index: 1;

    &--published {
      background-color: $color-genoa;
    }

    &--draft {
      background-color: $color-sunset;
    }

    &--empty {
      background-color: $color-abbey;
    } 
  }

  &__drag-handle {

    svg {
      width: rem(20px);
      height: rem(20px);
    }

    &:hover {
      cursor: move;
    }
  }

  &__drag-ghost {
    opacity: 0.5;
  }

  &__order {
    font-size: 0.6125rem;
    padding: 0.125rem 0.25rem;
    text-transform: uppercase;
    display: inline-block;
    line-height: 1;
    margin-top: 0.5rem;
    background: rgba(0,0,0,.1);
    color: #000;
    font-weight: 700;
  }

  &__title {
    color: $color-abbey;
    font-weight: 700;
    font-size: rem(20px);
    margin-bottom: rem(8px);
    padding-bottom: rem(8px);
    border-bottom: 1px solid rgba(0,0,0,.1);

    a {
      color: $color-abbey;
      transition: color .3s ease;

      &:hover {
        color: $color-java;
        text-decoration: none;
      }
    }
  }

  &__actions {
    margin-bottom: rem(16px);
  }

  &__action {
    margin: 0;
    padding: 0;
    border: 0;
    background: none;

    &:focus {
      outline: none;

      svg {
        fill: $color-genoa;
      }
    }

    svg {
      width: rem(16px);
      height: rem(16px);
      fill: $color-genoa;
      transition: fill .3s ease;

      &:hover {
        fill: $color-java;
      }
    }
  }

  &__last-updated {
    color: $color-abbey;
    text-transform: uppercase;
    margin-bottom: 0;
  }
}

.paragraph {
  position: relative;

  .card-body {
    padding-top: rem(8px);
    padding-bottom: rem(8px);
  }

  &__status {
    position: absolute;
    left: 0;
    top: 0;
    width: rem(10px);
    height: 100%;
    border-top-left-radius: rem(8px);
    border-bottom-left-radius: rem(8px);

    &--draft {
      background-color: $color-sunset;
    }   

    &--published {
      background-color: $color-genoa;
    }

    &--empty {
      background-color: $color-abbey;
    }
  }

  p {
    display: flex;
    align-items: center;
  }

  &__order {
    font-size: 0.6125rem;
    padding: 0.125rem 0.25rem;
    text-transform: uppercase;
    display: inline-block;
    line-height: 1;
    margin-right: 0.5rem;
    background: rgba(0,0,0,.1);
    color: #000;
    font-weight: 700;
  }
}
</style>